import React from 'react';
import PropTypes from 'prop-types';
import { LuWorkflow } from 'react-icons/lu';
import { useOplaUrls } from 'helpers/useAppSetting';

// Record types supported by the Opla CRM deep links exposed by `useOplaUrls`.
const RECORD_TYPES = ['customer', 'contact', 'project'];

const ARIA_LABEL = {
  customer: 'View this customer on Opla CRM (opens in new tab)',
  contact:  'View this contact on Opla CRM (opens in new tab)',
  project:  'View this project on Opla CRM (opens in new tab)',
};

/**
 * "View on Opla CRM" deep link, styled like the button used on the project
 * Discovery stage so every Opla ID row looks the same across CRM records.
 * Renders the empty placeholder when the record has not been synced yet.
 */
const OplaCrmLink = ({ type, oplaId, label = 'View on Opla CRM' }) => {
  const opla = useOplaUrls();

  if (!oplaId) return <span className="tw-text-slate-300">—</span>;

  return (
    <a
      href={`${opla[type]}/${oplaId}`}
      target="_blank"
      rel="noopener noreferrer"
      title={`Opla ID: ${oplaId}`}
      aria-label={ARIA_LABEL[type]}
      className="tw-inline-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded tw-border tw-border-blue-200 tw-bg-blue-50 tw-text-blue-600 tw-font-medium tw-text-sm tw-no-underline tw-transition-all hover:tw-bg-blue-100 hover:tw-border-blue-300 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-1"
    >
      <LuWorkflow size={14} className="tw-flex-shrink-0" />
      {label}
      <span className="tw-text-[10px] tw-font-bold tw-opacity-60" aria-hidden="true">↗</span>
    </a>
  );
};

OplaCrmLink.propTypes = {
  type:   PropTypes.oneOf(RECORD_TYPES).isRequired,
  oplaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label:  PropTypes.string,
};

export default OplaCrmLink;
